import { ColorScale } from '../utils/ColorScale';
import { usePaletteColorScale } from './usePaletteColorScale';

/**
 * Returns a color scale for use with the chart. If a color scale prop is specified, it is used;
 * otherwise, a new one is created using the specified palette.
 *
 * @param palette The palette to use, if a new color scale is returned.
 * @param colorScaleProp A color scale prop, if passed in.
 */
export const useChartColorScale = <TColor, TKey>(
  palette: readonly TColor[],
  colorScaleProp: ColorScale<TKey, TColor> | undefined,
): ColorScale<TKey, TColor> => {
  const defaultColorScale = usePaletteColorScale(palette);
  const colorScale = colorScaleProp ?? defaultColorScale;

  return colorScale;
};
